import { Component, Input } from '@angular/core';
import { Authentication } from 'core/auth'
import { CurrentUser } from 'models'

@Component({
  selector: 'role-switcher',
  styles: [
      `
      .drop-section-header {
        color: black;
        padding: 7px 7px 3px;
        font-size: 12px;
      }
      .sidebar__roles-list {
        margin: 0;
        padding: 0 15px;
      }
      .sidebar__roles-list-item {
        list-style: none;
        margin: 5px 0;
      }
    `
  ],
  template: `
    <drop [caption]="title()" [modificator]="modificator">
      <div class="drop__section drop-section-header">
        Выбор роли
      </div>
      <div class="drop__section drop-section-links">
        <ul class="sidebar__roles-list">
          <li class="sidebar__roles-list-item" *ngFor="let role of roles()">
            <a class="sidebar__roles-list-link" href="#" (click)="selectRole($event, role)">
              {{ currentUser.decorate().roleDecorator(role) }}
            </a>
          </li>
        </ul>
      </div>
    </drop>
  `
})

export class RoleSwitcherComponent {
  @Input('modificator') modificator: string|null = null
  public currentUser: CurrentUser

  private  disabledRoles = ['video_accessor']

  constructor(
    private authentication: Authentication 
  ) {
    this.currentUser = this.authentication.currentUser
  }

  roles(): string[] {
    return this.currentUser.roles.filter(role => {
      return role != this.currentUser.currentRole && this.disabledRoles.indexOf(role) == -1
    })
  }

  title(): string|null {
    return this.currentUser ? this.currentUser.decorate().role() : null
  }

  showRoleSwitcher(): boolean {
    return this.roles().length > 0
  }

  selectRole(e:Event, role:string):void {
    e.preventDefault()
    this.currentUser.currentRole = role
    window.location.reload()
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/components/role-switcher.component.ts